import { getEntries } from '@shared/objects';
import { iconsMap } from './Icon.data';

/** A semantic identifier for icons used in the application. */
export type IconId =
  | 'account'
  | 'backpack'
  | 'backpack-outline'
  | 'bars-3'
  | 'check-circle'
  | 'circle-outline'
  | 'close'
  | 'delete'
  | 'email'
  | 'gear'
  | 'home'
  | 'menu-open'
  | 'menu-close'
  | 'not-found'
  | 'packs'
  | 'sign-in'
  | 'sign-out'
  | 'trips'
  | 'alert-circle-outline'
  | 'check-circle-outline'
  | 'arrow-right'
  | 'eye-outline'
  | 'eye-off-outline'
  | 'register-outline'
  | 'google-logo'
  | 'spinner-circle-outline'
  | 'sun'
  | 'moon'
  | 'monitor'
  | 'credit-card'
  | 'help-circle'
  | 'account-cog'
  | 'ellipsis-horizontal'
  | 'settings'
  | 'check'
  | 'sliders'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'expand-all'
  | 'collapse-all'
  | 'drag'
  | 'star'
  | 'star-outline'
  | 'share'
  | 'camera'
  | 'copy'
  | 'link'
  | 'open-in-new'
  | 'download'
  | 'import'
  | 'plus'
  | 'code'
  | 'search'
  | 'refresh'
  | 'feedback'
  | 'bug'
  | 'lightbulb'
  | 'help'
  | 'list-bulleted'
  | 'italic';

export interface IconProps {
  /** Original key from Iconify (e.g. 'mdi:home') */
  originalKey: string;
  /** SVG viewBox dimensions */
  viewBox?: { minY?: number; minX?: number; width?: number; height?: number; size?: number };
  /** SVG path data */
  body: string;
}

export interface Icon extends IconProps {
  id: IconId;
}

export const icons = getEntries(iconsMap).map((each) => {
  const entry: Icon = { id: each[0], ...each[1] };
  return entry;
});

export function getIcon(id: IconId) {
  const found = icons.find((each) => each.id === id);
  if (!found) {
    throw new Error(`The icon with id '${id}' was not found.`);
  }
  return found;
}

/** Returns raw SVG markup for use outside Svelte (e.g. AG Grid `icons` option). */
export function getIconSvg(id: IconId, size: number | string = 16): string {
  const icon = getIcon(id);
  const minX = icon.viewBox?.minX ?? 0;
  const minY = icon.viewBox?.minY ?? 0;
  const width = icon.viewBox?.width ?? icon.viewBox?.size ?? 24;
  const height = icon.viewBox?.height ?? icon.viewBox?.size ?? 24;
  return `<svg width="${size}" height="${size}" viewBox="${minX} ${minY} ${width} ${height}" fill="currentColor">${icon.body}</svg>`;
}
